import React from 'react';
import { Dropdown } from 'react-bootstrap';
import ActivityFeed from '../ActivityFeed';
import Button from '../Button';
import { IconButton } from '../Button';
import getTimeOrDate from './getTimeOrDate';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
    notifications: {
        id: 'NotificationsMenu.notifications',
        defaultMessage: 'Notifications',
        description: 'The title of the notifications menu',
    },
    noNotifications: {
        id: 'NotificationsMenu.noNotifications',
        defaultMessage: 'No notifications',
        description: 'The message shown when there are no notifications',
    },
    seeAll: {
        id: 'NotificationsMenu.seeAll',
        defaultMessage: 'See all',
        description: 'The text of the button to see all notifications',
    },
});

function NotificationsMenu({ toLink = "", notifications, refetchCallback = () => { }, markAsRead }) {
    const intl = useIntl();
    if (!notifications) return null;
    return (
        <Dropdown.Menu className="notification-menu">
            <ActivityFeed>
                <ActivityFeed.Header className="notification-menu__header">
                    <div className="notification-menu__title">{intl.formatMessage(messages.notifications)}</div>
                    <div className="notification-menu__header-right">
                        <IconButton size="xs" variant="ghost-gray" icon="refresh" iconType="line" onClick={() => refetchCallback()} />
                        <Button as={Link} variant="ghost-gray" size="xs" iconAfter="fullscreen" iconType="line" to={toLink}>
                            {intl.formatMessage(messages.seeAll)}
                        </Button>
                    </div>
                </ActivityFeed.Header>
                <ActivityFeed.List>
                    {notifications.length === 0 ? (
                        <div className="notification-menu__no-notifications">{intl.formatMessage(messages.noNotifications)}</div>
                    ) : (
                        notifications.slice(0, 5).map((notification, index) => (
                            <React.Fragment key={notification.id}>
                                <ActivityFeed.Item
                                    index={index}
                                    className={classNames("notification-menu__item", {
                                        'notification-menu__item--unread': !notification.readStatus
                                    })}
                                    title={notification.notification.title.length > 30 ? `${notification.notification.title.substring(0, 30)}...` : notification.notification.title}
                                    description={notification.notification.message.length > 50 ? `${notification.notification.message.substring(0, 50)}...` : notification.notification.message}
                                    actions={
                                        <div className="notification-menu__item-time_status">
                                            <div className="notification-menu__item-time">
                                                {getTimeOrDate(notification.notification.createdAt)}
                                            </div>
                                            {!notification.readStatus && <div className="notification-menu__item-read-status" />}
                                        </div>
                                    }
                                    onClick={() => {
                                        if (!notification.readStatus) {
                                            markAsRead({
                                                variables: {
                                                    keyId: notification.id,
                                                    set: true
                                                }
                                            });
                                        }
                                    }}
                                />
                                {index !== Math.min(notifications.length, 5) - 1 && <ActivityFeed.Divider />}
                            </React.Fragment>
                        ))
                    )}
                </ActivityFeed.List>
            </ActivityFeed>
        </Dropdown.Menu>
    );
}

NotificationsMenu.propTypes = {
    toLink: PropTypes.string.isRequired,
    notifications: PropTypes.array.isRequired,
    refetchCallback: PropTypes.func.isRequired,
    markAsRead: PropTypes.func.isRequired
};

export default NotificationsMenu;